<!--绘图部分的tab标签的封装-->
<template>
  <div>
    <div v-if="!showTag">
      <el-tabs v-model="tabNames" >
        <el-tab-pane
          v-for="(itemSecond, indexSec) in tabList"
          :key="indexSec"
          :label="itemSecond.tagName"
          :name="itemSecond.tagName">
          <div v-for="(inElem, inIndex) in itemSecond.fileList" :key="inIndex" style="will-change: transform;">
            <p class="pictureName">{{ normalizeShowFileName(inIndex + 1, inElem.filename) }}
              <i class="el-icon-question pictureQuestion"
                 title="图片说明" ref="popoverElement" data-trigger="hover"
                 data-container="body" data-toggle="popover" data-placement="right" data-html="true"
                 :data-content="openPictureQuestion(inElem.filename,inElem.folder)">
              </i>
            </p>
            <div style="display: flex;width: 100%;margin-bottom: 50px">
              <FilePdf :projectId="projectId" :analyzeId="analyzeId" :path="path"
                       :folder="inElem.folder" :fileName="inElem.filename"
                       :ref="'pdf'+parseInt((indexSec+1).toString()+(inIndex+1).toString())"
                       :index="inIndex"
                       style="width:53%;height:675px" :types="'pdf'"
              ></FilePdf>
              <ModifyParam :analyzeId="analyzeId" :path="path" :projectId="projectId"
                           :folder="inElem.folder" :countType="'twoFloor'"
                           @updatePdf="updatePdf" :nonGroup="nonGroup"
                           :index="parseInt((indexSec+1).toString()+(inIndex+1).toString())"
                           style="width:42%"></ModifyParam>
            </div>
            <el-divider></el-divider>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
<!--    //超过6个需要搜索-->
    <div v-else>
      <el-tabs v-model="tabNames" >
        <el-tab-pane :name="tabNames">
          <template v-slot:label>
            <el-select v-model="tabNames" filterable placeholder="请选择" style="width: 280px"
                       @change="handleSelectedTag">
              <el-option
                v-for="(elemF, index) in tabList"
                :key="index"
                :label="elemF.tagName"
                :value="elemF.tagName">
              </el-option>
            </el-select>
          </template>
          <div v-for="(inElem, inIndex) in selectedTag.fileList" style="will-change: transform;"
               :key="inIndex+Math.random().toString(36).substring(2, 9)">
            <p class="pictureName">{{ normalizeShowFileName(inIndex + 1, inElem.filename) }}
              <i class="el-icon-question pictureQuestion" title="图片说明" :ref="`popover-${inIndex}`"></i>
            </p>
            <div style="display: flex;width: 100%;margin-bottom: 50px">
              <FilePdf :projectId="projectId" :analyzeId="analyzeId" :path="path"
                       :folder="inElem.folder" :fileName="inElem.filename"
                       :ref="'pdf'+parseInt(inIndex)"
                       :index="inIndex"
                       style="width:53%;height:675px;" :types="'pdf'"
              ></FilePdf>
              <ModifyParam :analyzeId="analyzeId" :path="path" :projectId="projectId"
                           :folder="inElem.folder" :countType="'twoFloor'"
                           :index="inIndex" :nonGroup="nonGroup"
                           style="width:42%" @updatePdf="updatePdf"></ModifyParam>
            </div>
            <el-divider></el-divider>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import '../jquery/jQuery-3.2.1'
import {getPictureCon, introducePicture} from "@/utils/notes";
import {checkIsNumber, normalizeShowFileName} from "@/utils/utils";
import ModifyParam from "@/components/ModifyParam";
import FilePdf from "@/components/FilePdf";
import {getDataInSessionStorage} from "@/utils/sessionStorage";
export default {
  name: "ModifyTabInner",
  components: {ModifyParam, FilePdf},
  props: {
    projectId: '',
    analyzeId: '',
    path: '',
    tabList: [],
    index: 0,
    tabName: '',
    showTag: Boolean,
    floor:0,
    nonGroup:Boolean,
  },
  data() {
    return {
      pathSplit: 0,
      pathIndexFir: 0,
      pathIndexSec: 0,
      tabNames: JSON.parse(JSON.stringify(this.tabName)),
      selectedTag: JSON.parse(JSON.stringify(this.tabList[0])),
      selectedTagIndex: 0,
    }
  },
  created() {
    var path = getDataInSessionStorage('lastPath')
    if(path){
      this.pathSplit = JSON.parse(JSON.stringify(path.lastIndexOf("/")))
      this.pathIndexFir = JSON.parse(JSON.stringify(path.substring(0, path.indexOf("."))))
      this.pathIndexSec = JSON.parse(JSON.stringify(path.substring(this.pathSplit + 1, this.pathSplit + 3)))
      if (!checkIsNumber(this.pathIndexSec, 'number')) {
        this.pathIndexSec = JSON.parse(JSON.stringify(path.substring(this.pathSplit + 1, path.length)))
      }
    }
  },
  mounted() {
    $("[data-toggle='popover']").popover();
    this.initPopover();
  },
  watch:{
    tabName(newValue, oldValue) {
      this.tabNames=newValue
    },
    'selectedTag.fileList': function() {
      this.initPopover();
    }
  },
  methods: {
    //初始化图片提示
    initPopover() {
      this.$nextTick(() => {
        for (let i = 0; i < this.selectedTag.fileList.length; i++) {
          $(this.$refs[`popover-${i}`]).popover({
            trigger: 'hover',
            container: 'body',
            placement: 'right',
            html: true,
            content: this.openPictureQuestion(this.selectedTag.fileList[i].filename, this.selectedTag.fileList[i].folder)
          });
        }
      });
    },
    handleSelectedTag(value) {
      const index = this.getIndexSelectTag(value, this.tabList)
      this.selectedTag = this.tabList[index]
      this.selectedTagIndex = index
      this.tagNames = this.tabList[index].tagNames
    },
    getIndexSelectTag(value, obj) {
      const index = obj.findIndex(obj => obj.tagName === value)
      return index
    },
    openPictureQuestion(fileName, folder) {
      const html = `${getPictureCon(fileName, folder)}`
      return `${html}`
    },
    normalizeShowFileName(third, name) {//规范名字的展示，01-01-01.xxx
      var finalName = normalizeShowFileName(this.pathIndexFir, this.pathIndexSec, third, name)
      if (finalName) {
        return finalName + '分析结果图'
      } else return ""
    },
    updatePdf(folder, index, count) {
      let currentIndex = 'pdf' + index
      this.$refs[currentIndex][0].getPdf(folder, 2)
    },
  },
}
</script>

<style scoped>
.pictureName {
  /*list-style-type: disc;*/
  color: #1e6cb0;
  margin: 30px 0px;
}

.pictureQuestion {
  cursor: pointer;
  /*color: #afbdde;*/
  color: #2a7fc9;

}
</style>
